import React from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./Leaflet.css";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import * as api from "../api";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: "http://localhost:3000/images/orient-city.png",
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  iconSize: [51, 34],
});

class Leaflet extends React.Component {
  state = {
    markers: [
      {
        x: 41.635700692731476,
        y: 45.675343349576,
        body:
          "An old decrepit castle, made of ancient stone. The party escaped from a group of Goblinoids that had taken up residence here with a winged lion beast. An elderly villager from nearby Applegrove advised the castle had been abandoned for hundereds of years",
        icon: "red-x",
        zoom: 3,
      },
      {
        x: 40.48038142908172,
        y: 44.0771484375,
        body:
          "The Villages of Applegrove, Shepling and Little Shepling. A cluster of farming settlements. The Alderman of Shepling, Barnabus, asked the party to fetch help from nearby Bordagant. The settlements are torn over whether to flee or fight the goblins",
        icon: "red-x",
        zoom: 4,
      },
      {
        x: 39.402244340292775,
        y: 41.26464843750001,
        body:
          "Berrickstead, a fortified hamlet with a central, thatched, rustic inn and a couple of farmsteads. The party removed a cursed humanoid from the local crypts and discovered that the dwarves of yore fled their ancient home with the help of a tiefling hero who died to save them. The young human noble and Derrick, who were rescued from the goblin castle left the group here, last seen heading down the road to Bordagant",
        icon: "red-x",
        zoom: 4,
      },
      {
        x: 40.1452892956766,
        y: 37.96875000000001,
        body:
          "Bordagant is the main city in the Fiefdom of Agant. It is renoun for it's silver mines and artisans. The Eastern side of the town is burnt down, a large Elven warship is docked in the bay and an invading army under the Empire of Elves has taken over with their main military camp in the Baron's old castle. The town houses, among other things, a Bawdy House known as 'The Feather' and an alchemist shop known as 'Remedaes of a Bonze Kettle'. The local Bailiff plans to buy off the goblins to the East and cares naught for the villages there",
        icon: "red-x",
        zoom: 3,
      },
      {
        x: 24.36756649642985,
        y: 3.8232421875000004,
        body:
          "The Free City of Talbrek. The largest city in the now dissolved Human Empire. Marion has a map of Talbrek",
        icon: "red-x",
        zoom: 3,
      },
      {
        x: 40.106945535908174,
        y: 48.86718750000001,
        body:
          "Gnomad's hut. Burnt down in the goblin raid that captured Gnomad and his adopted son, Shushek.",
        icon: "red-x",
        zoom: 5,
      },
      {
        x: 37.26082627951173,
        y: 55.23925781250001,
        body:
          "The Eastern Wildlands and Tundra where Willow and Marion roamed before the raids by the goblins.",
        icon: "red-x",
        zoom: 3,
      },
      {
        x: 45.82362897574766,
        y: 42.71484375000001,
        body:
          "The Northern Wild Forests Where Willow and Marion roamed before the raids by goblins. The territory is bordered by a wide river to the North and the lands beyond there are cold and inhospitable. The lands in the West contain the beginnings of Settlements",
        icon: "red-x",
        zoom: 3,
      },
    ],
    zoom: 5,
    scale: "80 miles",
  };

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    const { url, map } = this.props;
    return (
      <Map
        center={[41.7, 45.3]}
        zoom={5}
        maxZoom={5}
        minZoom={1}
        onzoomend={(e) => {
          const ref = e.target._zoom;
          let str = "";
          if (ref === 5) {
            str = "80 miles";
          } else if (ref === 4) {
            str = "160 miles";
          } else if (ref === 3) {
            str = "320 miles";
          } else if (ref === 2) {
            str = "640 miles";
          } else {
            str = "1280 miles";
          }

          this.setState({ zoom: e.target._zoom, scale: str });
        }}
        onclick={(e) => {
          console.log(e);
        }}
        style={{ width: "100vw", height: "90vh" }}
      >
        <TileLayer
          attribution="&copy;"
          url={`${url}/images/${map}/{z}/{x}/{y}.png`}
          continuousWorld={false}
          noWrap={true}
        />

        {this.state.markers.map((marker, i) => {
          return marker.zoom <= this.state.zoom ? (
            <Marker
              key={`marker-${i}`}
              position={[marker.x, marker.y]}
              icon={L.icon({
                iconUrl: `${url}/images/${marker.icon}.png`,
                iconSize: [10, 10],
              })}
            >
              <Popup>{marker.body}</Popup>
            </Marker>
          ) : null;
        })}
        <div
          style={{
            height: "2px",
            width: "128px",
            backgroundColor: "black",
            position: "fixed",
            bottom: "20px",
            right: "10px",
            zIndex: "2000",
          }}
        />
        <p
          style={{
            position: "fixed",
            bottom: "16px",
            right: "10px",
            margin: "0",
            color: "black",
            zIndex: "2000",
          }}
        >
          {this.state.scale}
        </p>
      </Map>
    );
  }
}

export default Leaflet;
